import styled from "styled-components";

export const ContainerMaisInformacoesPage = styled.div`
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 100vh;
`;
